angular
	.module('App.Repository')
	.factory 'CashMovementEventsRepository', ['BaseRepository', (BaseRepository) ->
		class CashMovementEventsRepository extends BaseRepository
			@resource = '/cash_movement_events'
			@isRestricted = true

		return new CashMovementEventsRepository()
	]
